var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSendGiftStep1 = function SvgSendGiftStep1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 69,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF1F3",
    fillRule: "nonzero",
    opacity: 0.649,
    cx: 34.5,
    cy: 34.5,
    r: 34.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.4 30.706-2.487 8.145h-9.63l1.247-9.555 9.783-.05h.006c.36 0 .69.166.906.456.217.29.28.657.174 1.004ZM75.951 48.55c-.146.478-.58.8-1.08.8h-6.957L68.95 41.4h9.184l-2.183 7.15ZM51.717 29.393l.61 9.458h-9.96l-3.496-9.393 12.846-.065Zm3.164 9.458-.611-9.472 13.689-.07-1.245 9.542H54.881Zm-1.877 10.5h-6.726l-2.961-7.952h9.175l.512 7.951Zm2.554 0-.513-7.952h11.337l-1.037 7.951h-9.787ZM83.27 28.18a3.643 3.643 0 0 0-2.95-1.482h-.02l-27.113.139a1.268 1.268 0 0 0-.36-.034c-.076.005-.15.02-.222.037l-14.86.076-.954-2.613A6.64 6.64 0 0 0 30.594 20h-4.32a1.274 1.274 0 0 0 0 2.548h4.32a4.078 4.078 0 0 1 3.805 2.636l10.715 29.389a4.217 4.217 0 0 0 2.962 2.643 3.783 3.783 0 0 0-.92 2.476 3.802 3.802 0 1 0 7.605 0c0-.89-.31-1.708-.823-2.357h15.708a3.78 3.78 0 0 0-.713 2.211 3.802 3.802 0 0 0 7.605 0 3.801 3.801 0 0 0-2.425-3.54 3.227 3.227 0 0 0-2.525-1.219H49.062a1.66 1.66 0 0 1-1.554-1.087l-.657-1.802h28.02a3.658 3.658 0 0 0 3.518-2.605l5.448-17.843a3.644 3.644 0 0 0-.568-3.27Z",
    fill: "#93A1AC"
  }))));
};
export default SvgSendGiftStep1;